export default __webpack_public_path__ + "static/media/learning-active.9eff41aa.svg";